import { render } from "./DefaultLayout.vue?vue&type=template&id=21d3e713"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=21d3e713&lang=scss"

import exportComponent from "/Users/aks/Desktop/WORK/Codes/HCL Harit/chatbot-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__